// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';

// register Swiper custom elements
register();

// Select the swiper-container element
const swiperEl = document.querySelector('swiper-container');

// Define custom styles to inject
const params = {
  injectStyles: [
    `
    .swiper-button-prev svg,
    .swiper-button-next svg {
      display: none;
    }
    .swiper-pagination-fraction {
      display: block !important;
      letter-spacing: 0.125rem;

      .swiper-pagination-current {
        font-size: 4rem;
        line-height: 4rem;
      }
    }
    .swiper-pagination-vertical {
      position: absolute !important;
      flex-direction: column;
      justify-content: flex-end;
      width: auto !important;
      margin: 0 !important;
      transform: translate3d(0px,-50%,0) !important;

      .swiper-pagination-bullet {
        margin: 0.25rem 0;
      }
    }
    `,
  ],
};

if (swiperEl) {
  // Assign the parameters to the swiper element
  Object.assign(swiperEl, params);

  // Initialize the Swiper element
  swiperEl.initialize();
}
